import style from "./style.module.scss";
import { NavLink } from "react-router-dom";

export default function MenuItem(props) {
  const { children, href, ..._props } = props;
  const _href = href || "javascript:void(0)";
  return (
    <div className={style.menu}>
      <NavLink {..._props} to={_href}>
        {children}
      </NavLink>
    </div>
  );
}
